"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const drawerHeaderTranslation = {
    addMembers: "Add Members",
    addCount: "Add {{count}}",
    noneSelected: "Select members to add",
    newPatientGroup: "New Patient Group",
    newInternalGroup: "New Internal Group",
    createGroupSuccessMessage: "group created successfully",
    editGroupSuccessMessage: "group updated successfully",
    newBroadcast: "New Broadcast",
    createBroadcastSuccessMessage: "broadcast created successfully",
    editBroadcastSuccessMessage: "broadcast updated successfully",
    minMembers: "At least {{minMemberCount}} members must be selected",
    deleteBroadcastSuccessMessage: "broadcast deleted successfully",
    deleteGroupSuccessMessage: "group deleted successfully",
    removeMemberSuccessMessage: "removed successfully",
    newEpisode: "New Episode",
};
exports.default = drawerHeaderTranslation;
